import { visitViewsContract } from "@clipboard-health/contract-home-health-api";
import { post } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { useMutation } from "@tanstack/react-query";

const RECORD_VISIT_VIEW_URL = `${environmentConfig.REACT_APP_HOME_HEALTH_API_URL}/v1/visits/:visitDisplayId/views`;

export function useRecordVisitView(visitId: string) {
  return useMutation({
    mutationFn: async () => {
      await post({
        url: RECORD_VISIT_VIEW_URL.replace(":visitDisplayId", visitId),
        data: {},
        requestSchema: visitViewsContract.createVisitView.body,
        responseSchema: visitViewsContract.createVisitView.responses[204],
      });
    },
  });
}
